var _defs, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.71,7.24A10.07,10.07,0,0,1,25.94,8a4.8,4.8,0,0,0,2.11-2.65,9.73,9.73,0,0,1-3,1.16,4.82,4.82,0,0,0-8.19,4.37,13.58,13.58,0,0,1-9.9-5,4.9,4.9,0,0,0-.65,2.43,4.8,4.8,0,0,0,2.13,4,4.85,4.85,0,0,1-2.17-.59v.05a4.83,4.83,0,0,0,3.85,4.72,5.12,5.12,0,0,1-1.26.15,3.9,3.9,0,0,1-.91-.08,4.86,4.86,0,0,0,4.48,3.35,9.66,9.66,0,0,1-5.95,2,8.77,8.77,0,0,1-1.15-.06A13.54,13.54,0,0,0,12.66,24,13.57,13.57,0,0,0,26.32,10.35c0-.21,0-.41,0-.62a9.68,9.68,0,0,0,2.41-2.49Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitterIcon.4a405feb0870ba0f01fad887385d28f9.svg";
export { ForwardRef as ReactComponent };